import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(33.000000, 27.000000)">
        <path
          d="M0.45 33L10.6 0.399999H19.4L29.55 33H21.75L17.55 16.5C17.15 14.8667 16.7167 13.1333 16.25 11.3C15.7833 9.46667 15.35 7.7 14.95 6H14.75C14.35 7.7 13.9333 9.46667 13.5 11.3C13.0667 13.1333 12.6333 14.8667 12.2 16.5L7.95 33H0.45ZM7.15 25.25V19.5H22.75V25.25H7.15Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
